<template>
    <div v-if="status === 'loaded'">
        <div class="admin-page text-center">
            <the-nav>
                <h1>Procuradores</h1>

                <div class="buttons-container">
                    <button class="btn btn-danger icon-wrapper"
                            @click="emptyFilters">
                        <i class="uq-icon bi-filter"></i>&nbsp;Limpiar filtros
                    </button>

                    <button class="btn btn-download icon-wrapper"
                            v-if="can('export.attorneys')"
                            @click="downloadAttorneys(filters)">
                        <i class="uq-icon bi-download"></i>
                    </button>

                    <button class="btn btn-secondary" type="button" @click="this.modalToShow = 'add-attorney'"
                            title="Nuevo procurador" v-if="can('attorney.store')">
                        <span>Añadir procurador</span>
                    </button>
                </div>
            </the-nav>

            <div class="row form-container" v-if="can('attorney.index')">
                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nombre: </label>
                        <input type="text" class="form-control" aria-label="Nombre" v-model="filters.name"
                               @input="search"/>
                    </div>
                </div>

                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Nº colegiado: </label>
                        <input type="text" class="form-control" aria-label="Nº colegiado"
                               v-model="filters.collegiate_number" @input="search"/>
                    </div>
                </div>

                <div class="col-4 form-wrapper">
                    <div class="form-group search-form">
                        <label class="form-label">Colegio: </label>
                        <input type="text" class="form-control" aria-label="Colegio" v-model="filters.college"
                               @input="search"/>
                    </div>
                </div>
            </div>

            <div class="admin-main">
                <v-table :meta="attorneys.meta" :pagination="attorneys.links.pagination" @pageChanged="pageChanged" v-if="status === 'loaded'">
                    <template v-slot:header>
                        <th>Nombre</th>
                        <th>DNI</th>
                        <th>Número de colegiado</th>
                        <th>Colegio</th>
                        <th class="fit">Acciones</th>
                    </template>

                    <template v-slot:body>
                        <tr v-for="attorney in attorneys.data">
                            <td>{{ attorney.name }} {{ attorney.surname }}</td>
                            <td>{{ attorney.dni }}</td>
                            <td>{{ attorney.collegiate_number }}</td>
                            <td>{{ attorney.college }}</td>
                            <td class="fit">
                                <div class="actions-container">
                                    <button class="btn btn-show" @click="showAttorney(attorney)"
                                            v-if="can('attorney.show')">
                                        <i class="uq-icon bi-eye"></i>
                                    </button>

                                    <button class="btn btn-edit" @click="editAttorney(attorney)"
                                            v-if="can('attorney.update')">
                                        <i class="uq-icon bi-pencil"></i>
                                    </button>

<!--                                    <button class="btn btn-delete" @click="deleteAttorney(attorney)"-->
<!--                                            v-if="can('attorney.destroy')">-->
<!--                                        <i class="uq-icon bi-trash"></i>-->
<!--                                    </button>-->
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!attorneys.data">
                            <td colspan="222222">No hay procuradores</td>
                        </tr>
                    </template>
                </v-table>

                <div v-if="status === 'loading'">
                    <div class="loader-container">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="status === 'errorPermissions' && user.roleName !== 'Admin'">
        No tienes permisos
    </div>

    <attorneys-list-show-modal v-if="modalToShow === 'show-attorney'" :attorney="selectedAttorney"
                               @closed="modalToShow = null"></attorneys-list-show-modal>
    <attorneys-list-edit-modal v-if="modalToShow === 'edit-attorney'" :attorney="selectedAttorney"
                               @closed="modalToShow = null; loadAttorneys()"></attorneys-list-edit-modal>
    <attorneys-list-delete-modal v-if="modalToShow === 'delete-attorney'" :attorney="selectedAttorney"
                                 @closed="modalToShow = null; loadAttorneys()"></attorneys-list-delete-modal>
    <attorneys-list-add-modal v-if="modalToShow === 'add-attorney'"
                              @closed="modalToShow = null; loadAttorneys()"></attorneys-list-add-modal>
</template>
<script>
import AttorneysListShowModal from "./parts/AttorneysListShowModal";
import AttorneysListEditModal from "./parts/AttorneysListEditModal";
import AttorneysListDeleteModal from "./parts/AttorneysListDeleteModal";
import AttorneysListAddModal from "./parts/AttorneysListAddModal";
import {can} from "../../helpers/Permissions";
import TheNav from "../layouts/TheNav";
import {downloadAttorneysXLSX} from "../../helpers/Exports";
import router from "../../router";
import {withTimeout} from "../../helpers/requests/RequestsCore";
import {getAttorneysPaginated} from "../../helpers/requests/RequestsAttorneys";
import VPagination from "../general/VPagination";
import {filtersToQueryParameters, setQueryParameters} from "../../helpers/Url";
import VTable from "../general/VTable";

export default {
    name: "AttorneysList",
    components: {
        VPagination,
        TheNav,
        AttorneysListAddModal,
        AttorneysListDeleteModal,
        AttorneysListEditModal,
        AttorneysListShowModal,
        VTable
    },
    setup() {
        return {
            can,
            downloadAttorneysXLSX,
        }
    },
    data() {
        return {
            status: 'loading',
            attorneys: [],
            attorney: null,
            selectedAttorney: null,
            modalToShow: null,
            user_permissions: window.permissions,

            do_search: true,

            filters: {
                name: '',
                collegiate_number: '',
                college: '',
                page: 1,
            },
            timers: {
                search: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    async mounted() {
        // Read query params to form filters
        await this.setQueryParametersAsFilters();
        await this.doSearch();
        this.status = 'loaded';
    },
    watch: {
        $route(to, from) {
            // Apply only if we are operating over the same view
            if (to.name === from.name) {
                // TODO: Watch this and just only change url query parameters when methods fire something? This will do the rest
                this.setQueryParametersAsFilters();

                // We force it to not search because of a two-requests problem
                if (this.do_search === true) {
                    this.doSearch();
                }

                this.do_search = true;
            }
        }
    },
    methods: {
        downloadAttorneys(filters) {
            this.$store.dispatch('app/setToastMessage', 'Procesando la descarga...');
            downloadAttorneysXLSX(filters);
        },
        async doSearch() {
            this.do_search = false;
            await this.setFiltersAsQueryParameters();
            await this.loadAttorneys();
        },
        emptyFilters() {
            this.filters = {
                name: '',
                collegiate_number: '',
                college: '',
                page: 1,
            };

            this.doSearch();
        },
        /**
         * Detects any query parameter in the url and loads it in the filters (if available)
         *
         * @returns {Promise<void>}
         */
        setQueryParametersAsFilters() {
            let query_parameters = router.currentRoute.value.query;

            if (query_parameters.name) {
                this.filters.name = query_parameters.name;
            } else {
                this.filters.name = '';
            }

            if (query_parameters.collegiate_number) {
                this.filters.collegiate_number = query_parameters.collegiate_number;
            } else {
                this.filters.collegiate_number = '';
            }

            if (query_parameters.college) {
                this.filters.college = query_parameters.college;
            } else {
                this.filters.college = '';
            }

            if (query_parameters.page) {
                this.filters.page = query_parameters.page;
            } else {
                this.filters.page = 1;
            }
        },
        /**
         * Sets the local filters as url query parameters.
         */
        setFiltersAsQueryParameters() {
            setQueryParameters('attorney.index', this.filters);
        },
        async loadAttorneys() {
            let query = filtersToQueryParameters(this.filters);

            this.attorneys = await getAttorneysPaginated(query);
        },
        search() {
            this.timers.search = withTimeout(async () => {
                this.filters.page = 1;
                await this.doSearch();
            }, this.timers.search, 250);
        },
        async pageChanged(page) {
            this.filters.page = page;
            await this.doSearch();
        },
        showAttorney(attorney) {
            this.modalToShow = 'show-attorney';
            this.selectedAttorney = attorney;
        },
        editAttorney(attorney) {
            this.modalToShow = 'edit-attorney';
            this.selectedAttorney = attorney;
        },
        deleteAttorney(attorney) {
            this.modalToShow = 'delete-attorney';
            this.selectedAttorney = attorney;
        },
        addAttorney() {
            this.modalToShow = 'add-attorney';
        }
    }
}
</script>
